/**
 * CompleteScreen - Game completion celebration
 */

import { useEffect, useState } from 'react';
import PipCharacter from '../characters/PipCharacter';
import ConfettiSystem from '../effects/ConfettiSystem';
import './CompleteScreen.css';

export default function CompleteScreen({ stars, totalLevels, onPlayAgain, onHome }) {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    requestAnimationFrame(() => setMounted(true));
  }, []);

  return (
    <div className={`complete-screen ${mounted ? 'mounted' : ''}`}>
      {/* Background with extra confetti */}
      <div className="complete-bg">
        <div className="complete-bg__gradient" />
        <ConfettiSystem count={40} duration={8000} />
      </div>

      {/* Content */}
      <div className="complete-content">
        {/* Trophy */}
        <div className="complete-trophy">🏆</div>

        {/* Title */}
        <h1 className="complete-title">
          <span className="complete-title__emoji">🎉</span>
          Amazing Job!
          <span className="complete-title__emoji">🎉</span>
        </h1>

        {/* Stats */}
        <div className="complete-stats">
          <div className="stat">
            <span className="stat__value">{totalLevels}</span>
            <span className="stat__label">Levels</span>
          </div>
          <div className="stat stat--stars">
            <span className="stat__value">⭐ {stars}</span>
            <span className="stat__label">Stars</span>
          </div>
        </div>

        {/* Pip */}
        <div className="complete-pip">
          <PipCharacter mood="excited" animation="celebrate" size="large" />
        </div>

        {/* Message */}
        <p className="complete-message">
          Pip is so proud of you!<br />
          You're a superstar! 🌟
        </p>

        {/* Buttons */}
        <div className="complete-buttons">
          <button className="btn btn--play" onClick={onPlayAgain}>
            🔄 Play Again
          </button>
          <button className="btn btn--home" onClick={onHome}>
            🏠 Home
          </button>
        </div>
      </div>
    </div>
  );
}
